import React, {
  useState,
  useCallback,
  useReducer,
  useEffect,
  useRef,
} from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SplitterLayout from "react-splitter-layout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Contacts from "./components/Contacts";
import Details from "./components/AlarmDetailsSplit";
import StepperDialog from "popup/StepperDialog";
import AddRemarkDialog from "popup/AddRemarkDialog";
import ChargeConfirmationDialog from "popup/ChargeConfirmationDialog";
import AlarmDataGrid from "./components/AlarmDataGrid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import AlarmsOnSameStorePopup from "popup/AlarmsOnSameStorePopup";
import ConfirmationReassign from "popup/ConfirmationReassign";
import { fetchAlarms } from "./apiService";
import dayjs from "dayjs";
import {
  saveAlarmRemark,
  confirmAlarmCharge,
  createSalesforceCase,
  confirmAlarmClose,
  tlmPostNewAlarmSuspension,
  tlmGetReceivedEmail,
} from "./apiService";
import AddCloseDialog from "popup/AddCloseDialog";
import { get } from "aws-amplify/api";
import { post } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import { I18n } from "aws-amplify/utils";
import { APIStatusDialog } from "components/APIStatusDialog";
import AlarmsFilter from "./components/AlarmsFilter";
import { Box, Grid } from "@mui/material";
import MoreActionsDialog from "popup/MoreActionsDialog"; // Import the new dialog
import SuspendAlarmDialog from "popup/SupendAlarmsDialog";
import SuspendQuickAlarmDialog from "popup/SuspendQuickAlarmDialog";
import { tlmPostAlarmSuspensionReactive } from "./apiService";
import ErrorReactiveDialog from "popup/ErrorReactiveDialog";
import StepperAlarmDialog from "popup/StepperAlarmDialog";
import utc from "dayjs/plugin/utc";
import LockDialog from "popup/LockDialog";
import ClosureRulesDialog from "popup/ClosureRulesDialog";
import pako from "pako";
import { getCheckboxPropsSelector } from "@mui/x-data-grid/hooks/features/rowSelection/utils";
import EmailAlarmPopup from "popup/EmailAlarmPopup";
import { RefreshContext, useRefresh } from "./RefreshContext";

dayjs.extend(utc);

const ALARMFILTERSWITCHES_STATE_KEY = "alarmFilterSwitches_state";

const reducer = (lastState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...lastState,
        searchFetched: false,
      };

    case "DATA_RECEIVED":
      const audit = action.value;
      if (Array.isArray(audit)) {
        audit.forEach((element) => {
          if (typeof element.timestamp === "number") {
            element.timestamp = dayjs(element.timestamp).format(
              "YYYY-MM-DD HH:mm"
            );
          }
        });
        return {
          audit: audit,
          fetched: true,
          searchFetched: true,
          lastUpdate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        };
      }
      break;

    default:
      return lastState;
  }
};

function Dashboard() {
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
    searchFetched: false,
    lastUpdate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
  });
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const { setRefreshCallback } = useRefresh();

  /* -------------------------------------------------------- HOOKS -------------------------------------------*/
  const theme = useTheme();
  const mobileDevice = !useMediaQuery(theme.breakpoints.up("md"));
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [remark2, setRemark2] = useState("");
  const [endDate, setEndDate] = useState(
    dayjs().utc().format("YYYY-MM-DD HH:mm:ss")
  );
  const [isReassignDialogOpen, setIsReassignDialogOpen] = useState(false);
  const [valueDuration, setValueDuration] = useState("");
  const [isLocked, setIsLocked] = useState(false); // State for lock
  const [calendarId, setCalendarId] = useState("");
  const [selectedRowDataPopup, setSelectedRowDataPopup] = useState([]);
  const [isAddNoteDialogOpen, setIsAddNoteDialogOpen] = useState(false);
  const [isSuspDialogOpen, setIsASuspDialogOpen] = useState(false);
  const [isAddCloseDialogOpen, setIsAddCloseDialogOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [isStepperDialogOpen, setIsStepperDialogOpen] = useState(false);
  const [isAlarmDialogOpen, setIsAlarmDialogOpen] = useState(false);
  const [isEmailAlarmDialogOpen, setIsEmailAlarmDialogOpen] = useState(false);
  const [isStepperAlarmDialogOpen, setIsStepperAlarmDialogOpen] =
    useState(false);
  const [isChargeConfirmationDialogOpen, setIsChargeConfirmationDialogOpen] =
    useState(false);
  const [isMoreActionsDialogOpen, setIsMoreActionsDialogOpen] = useState(false);
  const [resizeThrottle, setResizeThrottle] = useState(60);
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const [isSuspendDialogOpen, setIsSuspendDialogOpen] = useState(false);
  const [isQuickSuspendDialogOpen, setIsQuickSuspendDialogOpen] =
    useState(false);
  const [quickSuspendDuration, setQuickSuspendDuration] = useState("");
  const [deselect, setDeselect] = useState(false);
  const [isLockDialogOpen, setIsLockDialogOpen] = useState(false);
  const [isClosureRulesDialogOpen, setIsClosureRulesDialogOpen] =
    useState(false);
  const [alarmFilterSwitches, setAlarmFilterSwitches] = useState(() => {
    const cached = localStorage.getItem(ALARMFILTERSWITCHES_STATE_KEY);
    return cached ? JSON.parse(cached) : [1];
  });
  const [filterDuration, setFilterDuration] = useState();
  const [accountSelected, setAccountSelected] = useState();
  const [start, setStart] = useState();

  const [alarmFilterDateRange, setAlarmFilterDateRange] = useState([
    dayjs().startOf("day"),
    dayjs().endOf("day"),
  ]);

  /* -------------------------------------------------------- USE EFFECTS -------------------------------------------*/

  useEffect(() => {
    localStorage.setItem(
      ALARMFILTERSWITCHES_STATE_KEY,
      JSON.stringify(alarmFilterSwitches)
    );
  }, [alarmFilterSwitches]);

  useEffect(() => {
    if (selectedRowData && selectedRowData.length > 0) {
      const updatedSelectedRows = selectedRowData.map((selectedRow) => {
        return (
          state.audit.find((row) => row.id === selectedRow.id) || selectedRow
        );
      });
      setSelectedRowData(updatedSelectedRows);
    }
  }, [state.audit]);

  useEffect(() => {
    if (selectedRowDataPopup && selectedRowDataPopup.length > 0) {
      const updatedSelectedRows = selectedRowDataPopup.map((selectedRow) => {
        return (
          state.audit.find((row) => row.id === selectedRow.id) || selectedRow
        );
      });
      setSelectedRowDataPopup(updatedSelectedRows);
    }
  }, [state.audit]);

  /* -------------------------------------------------------- HANDLERS -------------------------------------------*/
  const [selectedIcon, setSelectedIcon] = useState(null); // State to track selected icon and row

  // Handlers for pop-ups with selected icon tracking
  const handlePopUpButtonClick = useCallback(
    (selectedRow, isFromCheckbox) => {
      if (isFromCheckbox) {
        if (showPopup === true) {
          showPopup2 && setShowPopup2(false);
          setSelectedRowData([selectedRow]);
          setShowPopup(true);
          setSelectedIcon({ rowId: selectedRow.id, icon: "info" }); // Track Info icon selection
        }
      } else {
        showPopup2 && setShowPopup2(false);
        setSelectedRowData([selectedRow]);
        setShowPopup(true);
        setSelectedIcon({ rowId: selectedRow.id, icon: "info" }); // Track Info icon selection
      }
    },
    [showPopup, showPopup2]
  );
  const [selectedRowId, setSelectedRowId] = useState(null);
  const handleSelectedRowId = (id) => {
    setSelectedRowId(id);
  };
  const handlePopUpButtonClick2 = useCallback(
    (selectedRow, isFromCheckbox) => {
      if (isFromCheckbox) {
        if (showPopup2 === true) {
          showPopup && setShowPopup(false);
          setSelectedRowData([selectedRow]);
          setShowPopup2(true);
          setSelectedIcon({ rowId: selectedRow.id, icon: "launch" }); // Track Launch icon selections
        }
      } else {
        showPopup && setShowPopup(false);
        setSelectedRowData([selectedRow]);
        setShowPopup2(true);
        setSelectedIcon({ rowId: selectedRow.id, icon: "launch" }); // Track Launch icon selection
      }
    },
    [showPopup, showPopup2] //It was showPopup
  );
  const [isManualRefresh, setIsManualRefresh] = useState(false);
  const fetchLists = async () => {
    try {
      dispatch({ type: "LOADING" });

      const startDate = dayjs(alarmFilterDateRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const endDate = dayjs(alarmFilterDateRange[1]).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      const response = await fetchAlarms(
        startDate,
        endDate,
        alarmFilterSwitches,
        language,
        accountSelected
      );
      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };
  const fetchLists2 = async (
    alarmFilterDateRange,
    alarmFilterSwitches,
    accountSelected
  ) => {
    try {
      dispatch({ type: "LOADING" });

      const startDateStr = dayjs(alarmFilterDateRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const endDateStr = dayjs(alarmFilterDateRange[1]).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      const isFullDayRange =
        startDateStr.endsWith("00:00:00") && endDateStr.endsWith("23:59:59");

      const startDate = isFullDayRange
        ? startDateStr
        : dayjs.utc(alarmFilterDateRange[0]).format("YYYY-MM-DD HH:mm:ss");
      const endDate = isFullDayRange
        ? endDateStr
        : dayjs.utc(alarmFilterDateRange[1]).format("YYYY-MM-DD HH:mm:ss");

      const response = await fetchAlarms(
        startDate,
        endDate,
        alarmFilterSwitches,
        language,
        accountSelected
      );

      dispatch({ type: "DATA_RECEIVED", value: response });
      // Resetta la flag dopo un aggiornamento manuale
      if (isManualRefresh) {
        setIsManualRefresh(false);
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };
  const refreshRef = useRef(() => {});
  const handleRefresh = () => {
    refreshRef.current();
  };
  useEffect(() => {
    refreshRef.current = () => {
      setIsManualRefresh(true);
      const startDateStr = dayjs(alarmFilterDateRange[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const endDateStr = dayjs(alarmFilterDateRange[1]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const isFullDayRange =
        startDateStr.endsWith("00:00:00") && endDateStr.endsWith("23:59:59");
      if (isFullDayRange) {
        fetchLists(alarmFilterDateRange, alarmFilterSwitches, accountSelected);
      } else {
        fetchLists2(alarmFilterDateRange, alarmFilterSwitches, accountSelected);
      }
    };
  }, [alarmFilterDateRange, alarmFilterSwitches, accountSelected, fetchLists, fetchLists2]);

  useEffect(() => {
    setRefreshCallback(()=>handleRefresh);
  },[]);

  const [isAutoRefresh, setIsAutoRefresh] = useState(true);
  const [isEffectRunning, setIsEffectRunning] = useState(true);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (isEffectRunning) {
      fetchLists2(alarmFilterDateRange, alarmFilterSwitches, accountSelected);
      const interval = setInterval(() => {
        fetchLists2(alarmFilterDateRange, alarmFilterSwitches, accountSelected);
      }, 180000);
      return () => clearInterval(interval);
    }

    if (isAutoRefresh) {
      const interval = setInterval(() => {
        if (filterDuration === "custom") {
          setAlarmFilterDateRange([
            alarmFilterDateRange[0],
            alarmFilterDateRange[1],
          ]);
          fetchLists2(
            [alarmFilterDateRange[0], alarmFilterDateRange[1]],
            alarmFilterSwitches,
            accountSelected
          );
        } else if (filterDuration === "" || filterDuration === null) {
          const newStartDate = dayjs(alarmFilterDateRange[1]).utc().format("YYYY-MM-DD 00:00:00");
          const newEndDate = dayjs(alarmFilterDateRange[1]).utc().format("YYYY-MM-DD 23:59:59");

          setAlarmFilterDateRange([newStartDate, newEndDate]);
          fetchLists2(
            [newStartDate, newEndDate],
            alarmFilterSwitches,
            accountSelected
          );
        } else {
          const now = dayjs.utc();
          const duration = dayjs
            .utc(alarmFilterDateRange[1])
            .diff(dayjs.utc(alarmFilterDateRange[0]), "milliseconds");
          const newStartDate = now
            .subtract(duration, "milliseconds")
            .toISOString();
          const newEndDate = now.toISOString();
          setAlarmFilterDateRange([newStartDate, newEndDate]);
          fetchLists2(
            [newStartDate, newEndDate],
            alarmFilterSwitches,
            accountSelected
          );
        }
      }, 180000);

      return () => clearInterval(interval);
    }
  }, [
    isEffectRunning,
    isAutoRefresh,
    alarmFilterSwitches,
    alarmFilterDateRange,
  ]);

  

  const transformRowSelection = (idsMap) => {
    const selectedRowsData = Array.from(idsMap).flatMap(([id, rowData]) => {
      if (id && !id.includes("auto-generated-row-null")) {
        return rowData ? [rowData] : [];
      }
      return [];
    });

    return selectedRowsData;
  };

  const handleReassignConfirm = async () => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: "Reassigning alarms",
      });
      setIsReassignDialogOpen(false);
      const restOperation = await tlmPostAlarmAccountRemap(
        selectedRowDataPopup
      );
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: "Reassigning alarms successfully",
        });
        setIsReassignDialogOpen(false);
        fetchLists();
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: "Failed to reassign alarms",
        });
      }
      fetchLists();
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: "Failed to reassign alarms",
      });
      fetchLists();
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
      console.error("Error reassigning alarms:", error);
    }
  };
  const handleRemarkSave = async (remark, selectedType) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Saving alarm remark"),
      });

      // Get the alarm IDs from selectedRowDataPopup
      const alarmIds =
        selectedRowDataPopup && selectedRowDataPopup.length > 0
          ? selectedRowDataPopup.map((row) => row.id)
          : []; // optional field, can be an empty array or null

      if (alarmIds.length === 0) return;

      // Replace special characters in selectedType with a space
      const sanitizedSelectedType = selectedType.replace(/[.,:!?]/g, " ");
      const combinedRemark = `${sanitizedSelectedType} ${remark}`;

      const restOperation = await saveAlarmRemark(alarmIds, combinedRemark);
      const response = await restOperation.response;

      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Alarms remark successfully saved"),
        });
        fetchLists();
        setSelectedRowDataPopup([]);
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to save alarm remark"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to save alarm remark"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    }
  };

  const handleCloseAlarmSave = async (
    remark,
    selectedTypeClose,
    selectedTypeCloseId
  ) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Closing Alarms"),
      });

      // Get the alarm IDs from selectedRowDataPopup
      const alarmIds =
        selectedRowDataPopup && selectedRowDataPopup.length > 0
          ? selectedRowDataPopup.map((row) => row.id)
          : []; // optional field, can be an empty array or null

      if (alarmIds.length === 0) return;

      // Replace special characters in selectedTypeClose with a space
      const sanitizedSelectedTypeClose = selectedTypeClose.replace(
        /[.,:!?]/g,
        " "
      );
      const combinedRemark = `${sanitizedSelectedTypeClose} ${remark}`.trim();

      const restOperation = await confirmAlarmClose(
        alarmIds,
        combinedRemark,
        selectedTypeCloseId
      );
      const response = await restOperation.response;

      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Closing Alarms successfully"),
        });
        fetchLists();
        setSelectedRowDataPopup([]);
      } else if (response.statusCode === 206) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get(
            "Succesfully closing alarms, but one or more alarms were already closed"
          ),
        });
        fetchLists();
        setSelectedRowDataPopup([]);
      } else if (response.statusCode === 409) {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("One or more alarms were already closed"),
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to close alarms"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    } catch (error) {
      if (error.response.statusCode === 409) {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("One or more alarms were already closed"),
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to close alarms"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
        handleRefresh();
      }, 1000);
    }
  };

  const handleSuspendAlarmSave = async (remark, utcEndDate, calendarId) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Suspending Alarms"),
      });

      // Get the alarm IDs from selectedRowDataPopup
      const alarmIds =
        selectedRowDataPopup && selectedRowDataPopup.length > 0
          ? selectedRowDataPopup.map((row) => row.id)
          : []; // optional field, can be an empty array or null

      if (alarmIds.length === 0) return;
      const restOperation = await tlmPostNewAlarmSuspension(
        alarmIds,
        remark,
        utcEndDate,
        calendarId,
        isLocked
      );

      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Suspending Alarms successfully"),
        });
        fetchLists();
        setSelectedRowData([]);
        setSelectedRowDataPopup([]);
      } else if (response.statusCode === 206) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get(
            "Suspending Alarms was successfull, but one or more alarms were already suspended or closed"
          ),
        });
        fetchLists();
        setSelectedRowData([]);
        setSelectedRowDataPopup([]);
      } else if (response.statusCode === 409) {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Conflict - Failed to suspend alarms"),
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to suspending alarms"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    } catch (error) {
      if (error.response.statusCode === 409) {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Conflict - Failed to suspend alarms"),
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to suspending alarms"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
        handleRefresh();
      }, 1000);
    }
  };
  // Handler to save charge confirmation for the selected alarm
  const handleChargeConfirmationSave = async (selectedRows) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Taking in charge"),
      });

      // Get the alarm IDs from selectedRowDataPopup
      const alarmIds =
        selectedRows && selectedRows.length > 0
          ? selectedRows.map((row) => row.id)
          : []; // optional field, can be an empty array or null

      if (alarmIds.length === 0) return;

      const restOperation = await confirmAlarmCharge(alarmIds);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Take in charge successfully"),
        });
        fetchLists();
        setTimeout(() => {
          setApiStatus((prevState) => ({ ...prevState, open: false }));
          setDeselect(true);
        }, 1000);
        setSelectedRowData(selectedRows); // Set the selected data
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to take in charge"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to take in charge"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    }
  };
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // const [billingCode, setBillingCode]=useState("")

  // Handler to save charge confirmation for the selected alarm
  const handleReactiveAlarmSave = async (idsMap) => {
    const selectedRows = transformRowSelection(idsMap);

    if (selectedRows.length === 0) {
      setErrorMessage(
        I18n.get("No data has been selected. Please select at least one row")
      );
      setErrorDialogOpen(true);
      return;
    }
    try {
      const allValidStates = selectedRows.every((row) => {
        return (
          row.state !== undefined &&
          (Number(row.state) === 3 || Number(row.state) === 4)
        );
      });

      // If not all states are valid, show error and stop execution
      if (!allValidStates) {
        setErrorMessage(
          "One or more selected alarms are not in the suspended state."
        );
        setErrorDialogOpen(true);
        return; // Stop further execution if any row has an invalid state
      }

      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Reactive alarms"),
      });

      // Get the alarm IDs from selectedRows
      const alarmIds =
        selectedRows && selectedRows.length > 0
          ? selectedRows.map((row) => row.id)
          : []; // optional field, can be an empty array or null

      if (alarmIds.length === 0) return;

      const restOperation = await tlmPostAlarmSuspensionReactive(alarmIds);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Reactive alarms successfully"),
        });
        fetchLists();
        setSelectedRowDataPopup([]);
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to reactive alarms"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to reactive alarms"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    }
  };

  const handleCreateSalesforceCase = async (formData) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Saving salesforce case"),
      });
      setIsStepperDialogOpen(false);
      const alarmIds = selectedRowDataPopup?.length
        ? selectedRowDataPopup.map((row) => row.id)
        : null;

      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/salesforce/case/post",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          body: {
            ...formData,
            alarm_ids: alarmIds,
          },
        },
      });
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Salesforce case successfully saved"),
        });
        fetchLists();
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to save salesforce case"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        selectedRowDataPopup &&
          selectedRowDataPopup.length > 0 &&
          setIsMoreActionsDialogOpen(true);
      }, 1000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: error.response.body,
        // message: I18n.get("Failed to save salesforce case"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 1000);
    }
  };

  const tlmPostAlarmAccountRemap = async (selectedRowDataPopup) => {
    try {
      const ids = selectedRowDataPopup.map((row) => row.id);
      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/alarm/account/map/remap",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          body: {
            ids: ids,
          },
        },
      });
      return restOperation;
    } catch (error) {
      console.error("Errore durante la chiamata API:", error);
    }
  };

  const handleCreateAlarm = async (formData) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Saving Alarm"),
      });
      setIsStepperAlarmDialogOpen(false);

      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/alarm/add/manual",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          body: {
            ...formData,
            datetime_end: formData.datetime_end
              ? dayjs(formData.datetime_end).utc().format("YYYY-MM-DD HH:mm:ss")
              : formData.datetime_end,
          },
        },
      });
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Alarm successfully created"),
        });
        fetchLists();
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to create alarm"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to create alarm"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    }
  };

  const handleRemoteConnection = async (selectedRow) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Connecting to remote device"),
      });

      //tlmGetAssetInfo (/accountNumber/asset/info/get) 
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/accountNumber/asset/info/get",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            alarm_id: selectedRow.id,
          },
        },
      });

      const { body } = await restOperation.response;
      const response = await body.json();
      const fslUrlLink = response[0]?.fsl_url_link;

      if (fslUrlLink) {
        if (fslUrlLink.includes("https://")) {
          setApiStatus({
            open: true,
            status: "success",
            message: I18n.get("Connecting to remote device successfully"),
          });
          window.open(fslUrlLink, "_blank");
        } else {
          setApiStatus({
            open: true,
            status: "error",
            message: fslUrlLink + I18n.get(" is not a valid URL")
          });
        }
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("FSL link not found"),
        }); 
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);

      return fslUrlLink;
    } catch (error) {
      console.error("Error fetching fsl link:", error);
       setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Connection to remote device failed"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        setDeselect(true);
      }, 1000);
    }
  }
  /* -------------------------------------------------------- COMPONENT -------------------------------------------*/

  const [profile, setProfile] = useState([]);
  const isGuest = profile.includes("Guest");
  const handleCloseAlarm = (idsMap, transformedIdsMap = null) => {
    const selectedRows = transformedIdsMap
      ? transformedIdsMap
      : transformRowSelection(idsMap);

    if (selectedRows.length === 0) {
      setErrorMessage(
        I18n.get("No data has been selected. Please select at least one row")
      );
      setErrorDialogOpen(true);
      return;
    }

    // const closed = selectedRows.some((row) => row.state === "2");

    // if (closed) {
    //   setErrorMessage(
    //     I18n.get("One of the selected alarms has been already closed")
    //   );
    //  setErrorDialogOpen(true);
    //   return;
    // }

    setErrorMessage(null);
    setSelectedRowDataPopup(selectedRows);
    setIsAddCloseDialogOpen(true);
    setIsMoreActionsDialogOpen(false);
  };

  const handleOpenNewSalesforceCase = (idsMap) => {
    const selectedRows = transformRowSelection(idsMap);

    if (selectedRows.length > 1) {
      const allSameAccount = selectedRows.every(
        (row) => row.account_number === selectedRows[0].account_number
      );

      if (!allSameAccount) {
        setErrorMessage(
          I18n.get("Account numbers are different. You cannot open the pop-up.")
        );
        setErrorDialogOpen(true);
        return;
      }
    }

    const hasOpenCase = selectedRows.some((row) => row.case_number);

    if (hasOpenCase) {
      setErrorMessage(
        I18n.get("An open case already exists in the selected alarms")
      );
      setErrorDialogOpen(true);
      return;
    }

    setErrorMessage(null);
    setSelectedRowDataPopup(selectedRows);
    setIsStepperDialogOpen(true);
  };

  const handleOpenSameStoreAlarm = (idsMap) => {
    const selectedRows = transformRowSelection(idsMap);

    if (selectedRows.length === 0) {
      setErrorMessage(
        I18n.get("No data has been selected. Please select at least one row")
      );
      setErrorDialogOpen(true);
      return;
    }

    if (selectedRows.length > 1) {
      const allSameAccount = selectedRows.every(
        (row) => row.account_number === selectedRows[0].account_number
      );

      if (!allSameAccount) {
        setErrorMessage(
          I18n.get("Account numbers are different. You cannot open the pop-up.")
        );
        setErrorDialogOpen(true);
        return;
      }
    }

    setErrorMessage(null);
    setSelectedRowDataPopup(selectedRows);
    setIsAlarmDialogOpen(true);
  };

  const handleOpenMailAlarm = (idsMap, isStart) => {
    const selectedRows = transformRowSelection(idsMap);

    if (selectedRows.length === 0) {
      setErrorMessage(
        I18n.get("No data has been selected. Please select at least one row")
      );
      setErrorDialogOpen(true);
      return;
    } else if (selectedRows.length > 1) {
      setErrorMessage(
        I18n.get("Cannot show more than one emails. Please select one row")
      );
      setErrorDialogOpen(true);
    } else {
      setErrorMessage(null);
      setSelectedRowDataPopup(selectedRows);
      setStart(isStart);
      setIsEmailAlarmDialogOpen(true);
    }
  };

  const handleAddRemark = (idsMap, transformedIdsMap = null) => {
    const selectedRows = transformedIdsMap
      ? transformedIdsMap
      : transformRowSelection(idsMap);
    const noDataSelected = selectedRows.length === 0;
    const closed = selectedRows.some((row) => row.state === "2");

    if (noDataSelected) {
      setErrorMessage(
        I18n.get("No data has been selected. Please select at least one row")
      );
      setErrorDialogOpen(true);
      return;
    } else if (closed) {
      setErrorMessage(
        I18n.get("One of the selected alarms has been already closed")
      );
      setErrorDialogOpen(true);
      return;
    }

    setErrorMessage(null);
    setSelectedRowDataPopup(selectedRows);
    setIsAddNoteDialogOpen(true);
    setIsMoreActionsDialogOpen(false);
  };

  const handleTakeInCharge = (idsMap) => {
    const selectedRows = transformRowSelection(idsMap);
    if (selectedRows.length === 0) {
      setErrorMessage(
        I18n.get("No data has been selected. Please select at least one row")
      );
      setErrorDialogOpen(true);
      return;
    }
    const closed = selectedRows.some((row) => row.state === "2");

    if (closed) {
      setErrorMessage(
        I18n.get("One of the selected alarms has been already closed")
      );
      setErrorDialogOpen(true);
      return;
    }

    setErrorMessage(null);
    handleChargeConfirmationSave(selectedRows);
  };

  const handleReassignAlarm = (idsMap) => {
    const selectedRows = transformRowSelection(idsMap);
    if (selectedRows.length === 0) {
      setErrorMessage(
        I18n.get("No data has been selected. Please select at least one row")
      );
      setErrorDialogOpen(true);
      return;
    }
    const closed = selectedRows.some((row) => row.state === "2");

    setErrorMessage(null);
    setSelectedRowDataPopup(selectedRows);
    setIsReassignDialogOpen(true);
  };

  const handleSuspendAlarm = (idsMap, transformedIdsMap = null) => {
    const selectedRows = transformedIdsMap
      ? transformedIdsMap
      : transformRowSelection(idsMap);

    if (selectedRows.length === 0) {
      setErrorMessage(
        I18n.get("No data has been selected. Please select at least one row")
      );
      setErrorDialogOpen(true);
      return;
    }
    // const suspended = selectedRows.some(
    //   (row) => row.state === "2" || row.state === "3" || row.state === "4"
    // );

    // if (suspended) {
    //   setErrorMessage(
    //     I18n.get("One of the selected alarms has been already suspended")
    //   );
    //   setErrorDialogOpen(true);
    //   return;
    // }

    setErrorMessage(null);
    setSelectedRowDataPopup(selectedRows);
    setIsSuspendDialogOpen(true);
    setIsMoreActionsDialogOpen(false);
  };

  const handleQuickSuspendAlarm = (idsMap, transformedIdsMap = null) => {
    const selectedRows = transformedIdsMap
      ? transformedIdsMap
      : transformRowSelection(idsMap);

    if (selectedRows.length === 0) {
      setErrorMessage(
        I18n.get("No data has been selected. Please select at least one row")
      );
      setErrorDialogOpen(true);
      return;
    }
    setErrorMessage(null);
    setSelectedRowDataPopup(selectedRows);
    setIsQuickSuspendDialogOpen(true);
    setIsMoreActionsDialogOpen(false);
  };

  // console.log("sel:", selectedRowData);
  function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    }
  }
  const browser = getBrowserName();
  useEffect(() => {
    if (browser === "Firefox") {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "auto";
      };
    }
  }, []);
  const useDynamicMaxHeight = () => {
    const [maxHeight, setMaxHeight] = useState("92vh");
    useEffect(() => {
      const screenHeight = window.screen.height;
      if (screenHeight >= 1440) {
        //27''
        setMaxHeight("92vh");
      } else if (screenHeight >= 1080) {
        //24''
        setMaxHeight("91vh");
      } else {
        setMaxHeight("91vh");
      }
    }, []);
    return maxHeight;
  };
  const maxHeight = useDynamicMaxHeight();

  const [tableHeight, setTableHeight] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const navbarHeight = document.getElementById("navbar");
      const footerHeight = document.getElementById("footer");
      const availableHeight =
        document.documentElement.clientHeight -
        navbarHeight -
        footerHeight -
        90;
      setTableHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar
          absolute
          light
          language={language}
          setLanguage={setLanguage}
          setProfile={setProfile}
        />
        <SplitterLayout
          vertical={mobileDevice}
          percentage={true}
          primaryIndex={0}
          primaryMinSize={mobileDevice ? 30 : 40}
          secondaryMinSize={35}
          secondaryInitialSize={mobileDevice ? 30 : 50}
          onDragStart={() => {
            setResizeThrottle(10000);
          }}
          onDragEnd={() => {
            setResizeThrottle(60);
          }}
          customClassName="splitter-layout-custom"
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box sx={{ p: 2, maxHeight: `${tableHeight}px` }}>
                <AlarmDataGrid
                  tableHeight={tableHeight}
                  onRowSelect={handleSelectedRowId}
                  resizeThrottle={resizeThrottle}
                  setSelectedRowData={setSelectedRowData}
                  selectedRowDataPopup={selectedRowDataPopup}
                  setSelectedRowDataPopup={setSelectedRowDataPopup}
                  handlePopUpButtonClick={handlePopUpButtonClick}
                  handlePopUpButtonClick2={handlePopUpButtonClick2}
                  handleRemoteConnection={handleRemoteConnection}
                  onRowSelection={handlePopUpButtonClick}
                  isAddCloseDialogOpen={isAddCloseDialogOpen}
                  handleChargeConfirmationSave={handleChargeConfirmationSave}
                  handleOpenNewSalesforceCase={handleOpenNewSalesforceCase}
                  handleOpenSameStoreAlarm={handleOpenSameStoreAlarm}
                  handleOpenMailAlarm={handleOpenMailAlarm}
                  handleReactiveAlarmSave={handleReactiveAlarmSave}
                  handleCloseAlarmSave={handleCloseAlarmSave}
                  setIsAddCloseDialogOpen={setIsAddCloseDialogOpen}
                  setIsStepperDialogOpen={setIsStepperDialogOpen}
                  setIsAddNoteDialogOpen={setIsAddNoteDialogOpen}
                  setIsStepperAlarmDialogOpen={setIsStepperAlarmDialogOpen}
                  setIsChargeConfirmationDialogOpen={
                    setIsChargeConfirmationDialogOpen
                  }
                  handleReassignAlarm={handleReassignAlarm}
                  setIsSuspendDialogOpen={setIsSuspendDialogOpen}
                  setIsLockDialogOpen={setIsLockDialogOpen}
                  setIsClosureRulesDialogOpen={setIsClosureRulesDialogOpen}
                  language={language}
                  profile={profile}
                  state={state}
                  dispatch={dispatch}
                  alarmFilterSwitches={alarmFilterSwitches}
                  setAlarmFilterSwitches={setAlarmFilterSwitches}
                  alarmFilterDateRange={alarmFilterDateRange}
                  setAlarmFilterDateRange={setAlarmFilterDateRange}
                  handleAddRemark={handleAddRemark}
                  handleCloseAlarm={handleCloseAlarm}
                  handleTakeInCharge={handleTakeInCharge}
                  handleSuspendAlarm={handleSuspendAlarm}
                  handleQuickSuspendAlarm={handleQuickSuspendAlarm}
                  quickSuspendDuration={quickSuspendDuration}
                  setQuickSuspendDuration={setQuickSuspendDuration}
                  selectedIcon={selectedIcon}
                  showPopup={showPopup}
                  showPopup2={showPopup2}
                  deselect={deselect}
                  setDeselect={setDeselect}
                  fetchLists={fetchLists2}
                  isManualRefresh={isManualRefresh}
                  setIsManualRefresh={setIsManualRefresh}
                  handleRefresh={handleRefresh}
                  setIsEffectRunning={setIsEffectRunning}
                  isAutoRefresh={isAutoRefresh}
                  isEffectRunning={isEffectRunning}
                  searchText={searchText}
                  setSearchText={setSearchText}
                  filterDuration={filterDuration}
                  setFilterDuration={setFilterDuration}
                  accountSelected={accountSelected}
                  setAccountSelected={setAccountSelected}
                />
              </Box>
            </Grid>
          </Grid>
          {showPopup && (
            <Contacts
              isOpen={showPopup}
              onClose={() => setShowPopup(false)}
              rowData={selectedRowData}
              language={language}
              fetchLists={fetchLists}
            />
          )}
          {showPopup2 && (
            <Details
              isOpen={showPopup2}
              onClose={() => setShowPopup2(false)}
              rowData={selectedRowData}
              language={language}
              profile={profile}
              fetchLists={fetchLists}
            />
          )}
        </SplitterLayout>
      </DashboardLayout>
      <AddRemarkDialog
        open={isAddNoteDialogOpen}
        onClose={() => setIsAddNoteDialogOpen(false)}
        onSave={handleRemarkSave}
        alarm={selectedRowDataPopup}
        language={language}
      />
      <AddCloseDialog
        open={isAddCloseDialogOpen}
        onClose={() => setIsAddCloseDialogOpen(false)}
        onSave={handleCloseAlarmSave}
        alarm={selectedRowDataPopup}
        language={language}
      />

      <SuspendAlarmDialog
        open={isSuspendDialogOpen}
        onClose={() => setIsSuspendDialogOpen(false)}
        onSave={handleSuspendAlarmSave}
        alarm={selectedRowDataPopup}
        language={language}
        setEndDate={setEndDate}
        endDate={endDate}
        calendarId={calendarId}
        setCalendarId={setCalendarId}
        setIsLocked={setIsLocked}
        isLocked={isLocked}
        setValueDuration={setValueDuration}
        valueDuration={valueDuration}
      />
      <SuspendQuickAlarmDialog
        open={isQuickSuspendDialogOpen}
        onClose={() => setIsQuickSuspendDialogOpen(false)}
        onSave={handleSuspendAlarmSave}
        alarm={selectedRowDataPopup}
        language={language}
        setEndDate={setEndDate}
        endDate={endDate}
        isLocked={isLocked}
        setIsLocked={setIsLocked}
        setValueDuration={setValueDuration}
        valueDuration={quickSuspendDuration}
      />

      {/* <SuspendAlarmDialog
        open={isSuspendDialogOpen}
        onClose={() => setIsSuspendDialogOpen(false)}
        onSave={handleSuspendAlarmSave}
        alarm={selectedRowDataPopup}
        language={language}
        remark={remark2}
        setRemark={setRemark2}
        setEndDate={setEndDate}
        endDate={endDate}
        setIsLocked={setIsLocked}
        isLocked={isLocked}
        calendarId={calendarId}
        setCalendarId={setCalendarId}
        setValueDuration={setValueDuration}
        valueDuration={valueDuration}
      /> */}
      <LockDialog
        open={isLockDialogOpen}
        onClose={() => {
          setIsLockDialogOpen(false);
          handleRefresh();
        }}
        language={language}
        isGuest={isGuest}
      />
      <ClosureRulesDialog
        open={isClosureRulesDialogOpen}
        onClose={() => {
          setIsClosureRulesDialogOpen(false);
          handleRefresh();
        }}
        language={language}
      />
      {isAlarmDialogOpen && (
        <AlarmsOnSameStorePopup
          open={isAlarmDialogOpen}
          onClose={() => setIsAlarmDialogOpen(false)}
          data={selectedRowDataPopup}
          language={language}
        />
      )}

      {isEmailAlarmDialogOpen && (
        <EmailAlarmPopup
          isOpen={isEmailAlarmDialogOpen}
          onClose={() => setIsEmailAlarmDialogOpen(false)}
          alarmId={selectedRowId + ""}
          start={start}
        />
      )}

      {isStepperDialogOpen && (
        <StepperDialog
          open={isStepperDialogOpen}
          onClose={() => setIsStepperDialogOpen(false)}
          alarm={selectedRowDataPopup}
          step={selectedRowDataPopup ? 1 : 0}
          handleCreateSalesforceCase={handleCreateSalesforceCase}
          onSave={handleCreateSalesforceCase}
          selectedRowData={selectedRowData}
          // billingCode={billingCode}
        />
      )}
      {isStepperAlarmDialogOpen && (
        <StepperAlarmDialog
          open={isStepperAlarmDialogOpen}
          onClose={() => setIsStepperAlarmDialogOpen(false)}
          step={0}
          handleCreateAlarm={handleCreateAlarm}
        />
      )}
      <MoreActionsDialog
        open={isMoreActionsDialogOpen}
        onClose={() => {
          setSelectedRowDataPopup([]);
          setIsMoreActionsDialogOpen(false);
        }}
        onAddRemark={() => {
          handleAddRemark(null, selectedRowDataPopup);
          setIsMoreActionsDialogOpen(false);
        }}
        onCloseAlarm={() => {
          handleCloseAlarm(null, selectedRowDataPopup);
          setIsMoreActionsDialogOpen(false);
        }}
        onSuspend={() => {
          handleSuspendAlarm(null, selectedRowDataPopup);
          setIsMoreActionsDialogOpen(false);
        }}
        language={language}
      />
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
      <ErrorReactiveDialog
        open={errorDialogOpen}
        onClose={() => setErrorDialogOpen(false)}
        message={errorMessage}
      />
      <ConfirmationReassign
        open={isReassignDialogOpen}
        onClose={() => setIsReassignDialogOpen(false)}
        onConfirm={handleReassignConfirm}
      />
    </>
  );
}

export default Dashboard;
